import { HttpErrorResponse } from "@angular/common/http";

import { CountryModel } from "@models/country.model";
import { createAction, props } from "@ngrx/store";

export const COUNTRY_ACTION_FAILURE = createAction(
  "[Country] Country Action Failure",
  props<{ error: HttpErrorResponse }>()
);

export const SET_COUNTRIES_LOADING = createAction(
  "[Country] Set Countries Loading",
  props<{ loading: boolean }>()
);

export const SET_COUNTRIES = createAction(
  "[Country] Set Countries",
  props<{ data: CountryModel[] }>()
);

export const LOAD_COUNTRIES = createAction("[Country] Load Countries");
